module.exports = __webpack_public_path__ + "static/media/1POLICY30.9cf54133.jpg";